import { formatDate, addDays, addMonths } from "date-fns";
import { ChevronLeft, ChevronRight } from "lucide-react";
import * as React from "react";
import styled from "styled-components";
import { humanDate } from "../utils/humanDate";

interface Props {
  date: Date;
  mode?: "month" | "week" | "day";
  setDate(date: Date): void;
  children?: React.ReactNode;
}

function DateNavRoot({ date, mode = "day", setDate, children }: Props) {
  const strDate = mode === "month" ? formatDate(date, "MMM yyyy") : humanDate(date);
  const increment = (amount: number) => {
    switch (mode) {
      case "day":
        return setDate(addDays(date, amount));
      case "month":
        return setDate(addMonths(date, amount));
      case "week":
        return setDate(addDays(date, amount * 7));
    }
  };
  return (
    <Container>
      <DateHeader data-testid="date-nav-current" title={date.toISOString()}>
        {strDate}
      </DateHeader>
      <DateActions>
        <Button onClick={() => increment(-1)}>
          <ChevronLeft size={16} color="var(--text-secondary-color)" />
        </Button>
        <Button onClick={() => increment(1)}>
          <ChevronRight size={16} color="var(--text-secondary-color)" />
        </Button>
        {children}
      </DateActions>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0 10px 10px;
`;

const DateHeader = styled.div`
  font-size: 16px;
  font-weight: 300;
  opacity: 0.75;
  flex-grow: 1;
`;

const DateActions = styled.div`
  display: flex;
  gap: 5px;
`;

const Button = styled.button`
  width: 25px;
  height: 25px;
  border-radius: 100%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--box-color);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  > svg {
    display: block;
  }
`;

const Link = styled.button`
  height: 25px;
  border-radius: 5px;
  font-size: 12px;
  letter-spacing: 0.01em;
  padding: 5px 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--box-color);
  color: var(--text-secondary-color);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

export const DateNav = Object.assign(DateNavRoot, { Button, Link });
